(function () {
  angular
    .module("akitabox.desktop.directives.noteInput", [
      "akitabox.core.services.user",
    ])
    .directive("abxNoteInput", AbxNoteInputDirective);

  function AbxNoteInputDirective() {
    return {
      restrict: "E",
      templateUrl: "app/desktop/directives/note-input/note-input.html",
      controller: AbxNoteInputController,
      controllerAs: "vm",
      bindToController: true,
      scope: {
        onChange: "&abxOnChange",
        hasRequester: "=?abxHasRequester",
      },
    };
  }

  /*
   * @ngInject
   */
  function AbxNoteInputController($scope, UserService) {
    var self = this;

    var userPerms = UserService.getPermissions();

    // Attributes
    self.hasRequester = self.hasRequester || false;
    self.canSendPublic = canSendPublic();
    self.messagePlaceholder = self.canSendPublic
      ? "Send a message to the requester or add an internal only message for your team."
      : "Add an internal message.";

    // Functions
    self.addNote = addNote;

    function addNote(isPublic) {
      self.onChange({
        noteText: self.noteText,
        sendToRequester: isPublic,
      });
      $scope.noteForm.$setPristine();
      $scope.noteForm.$setUntouched();
      self.noteText = "";
    }

    function canSendPublic() {
      // with the new perms, we only allow those with create_public to send messages to requesters
      return self.hasRequester && userPerms.comment.create_public;
    }
  }
})();
